import { useEffect } from "react"

interface UseFocusArgs {
  element: HTMLElement | null
  onFocus?: (ev: FocusEvent) => void
  onBlur?: (ev: FocusEvent) => void
  isDisabled?: boolean
}

export function useFocus({
  element,
  onFocus,
  onBlur,
  isDisabled = false
}: UseFocusArgs) {
  useEffect(() => {
    if (!isDisabled) {
      if (onFocus) element?.addEventListener("focusin", onFocus)
      if (onBlur) element?.addEventListener("blur", onBlur)
    }

    return () => {
      if (onFocus) element?.removeEventListener("focusin", onFocus)
      if (onBlur) element?.removeEventListener("blur", onBlur)
    }
  }, [element, isDisabled, onFocus, onBlur])
}
